import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { queryKey } from '../../../../../constant/queryKey';
import { marketService } from 'shared/src/api';
import type { GetMarketParentCategoriesResponse } from 'shared/src/api/marketService/getMarketParentCategories/types';

export const useParentMarketCategoriesQuery = (
  marketId: number,
  options?: Omit<
    UseQueryOptions<GetMarketParentCategoriesResponse>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery<GetMarketParentCategoriesResponse>({
    queryKey: queryKey.marketParentCategories(marketId),
    queryFn: () => marketService.getMarketParentCategories(marketId),
    ...options,
  });
};

